<button [attr.type]="type" [disabled]="disabled || loading" (click)="handleClick()" class="tracking-wide flex items-center justify-center py-[10px] border-2
        rounded-full transition duration-200 ease-in-out focus:outline-none  text-base font-medium"
  [ngClass]="getButtonClasses()">

  <div [ngClass]="[loading ? 'opacity-0' : 'opacity-100']" class="flex items-center px-4 gap-2 justify-center">
    @if (((icon || iconTemplate) && iconPosition === 'left')) {
    <ng-container>
      @if (((icon || iconTemplate) && iconPosition === 'left')) {
      <span class="flex shrink-0 items-center">
        <vw-icon-svg [iconUrl]="icon" class="text-white flex items-center"
          [additionalClasses]="'inline text-white' + iconCustomClass">
        </vw-icon-svg>
        @if (iconTemplate) {
          <ng-container>
            <ng-template [ngTemplateOutlet]="iconTemplate"></ng-template>
          </ng-container>
        }
      </span>
      }
    </ng-container>
    }
    <span class="overflow-hidden text-ellipsis">{{ label | translate }}</span>
    @if ((icon || iconTemplate) && iconPosition === 'right') {
    <ng-container>
      <span>
        <!-- adapt icon size -->
        <vw-icon-svg [iconUrl]="icon" class="text-white" [additionalClasses]="'inline text-white' + iconCustomClass">
        </vw-icon-svg>
        @if (iconTemplate) {
          <ng-container>
            <ng-template [ngTemplateOutlet]="iconTemplate"></ng-template>
          </ng-container>
        }
      </span>
    </ng-container>
    }
  </div>
  <ng-container>
    <vw-loading-icon class="inline text-white absolute"
      [ngClass]="loading ? 'opacity-100' : 'opacity-0'"></vw-loading-icon>
  </ng-container>
</button>